// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"221bc8ef","465":"d3621763","787":"1ed0c42c"}[chunkId] + ".chunk.js";
};